import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadList, loadListSuccess, loadListFailure, loadObjectSuccess } from '../lib/action';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { MasterdataService, AdministrationService } from '../service';
import { CommonService } from '../service/common/common.service';

@Injectable()
export class ListEffects {
  constructor(
    private actions$: Actions,
    private masterdataService: MasterdataService,
    private adminService: AdministrationService,
    private commonService:CommonService
  ) {}

  loadList$ = createEffect(() =>
    
    this.actions$.pipe(
      ofType(loadList),
      concatMap(({ listType }) => {
        switch (listType) {
          case 'profile':
            return this.commonService.getProfileDetails().pipe(
              map(res => {
                localStorage.setItem('profile', JSON.stringify(res));
                return loadObjectSuccess({ listType, data: res });
              }),
              catchError(error => {
                return of(loadListFailure({ listType, error }));
              })
            );
          // case 'privileges':
          //   return this.adminService.getApplicationPrivileges().pipe(
          //     map(res => {
          //       const items = 'results' in res ? res.results : [];
          //       return loadListSuccess({ listType, items });
          //     }),
          //     catchError(error => of(loadListFailure({ listType, error })))
          //   );  
          default:
            return of(loadListFailure({ listType, error: 'Unknown list type' }));
        }
      })
    )
  );
}
